// Signature strokes: canonical JSON is the evidence; the SVG is only a picture of it.
import { canonicalHash } from "./canonical.ts";
import { validateStroke, type Stroke } from "./schema.ts";

export async function strokeHash(s: Stroke): Promise<string> {
  const errs = validateStroke(s);
  if (errs.length) throw new Error(errs.join("; "));
  return canonicalHash(s);
}

export function strokeToSvg(s: Stroke, strokeWidth = 5): string {
  const paths = s.strokes
    .map((line) => {
      if (line.length === 1) {
        const [x, y] = line[0]!;
        return `<circle cx="${x}" cy="${y}" r="${strokeWidth / 2}" fill="currentColor"/>`;
      }
      const d = line.map(([x, y], i) => `${i ? "L" : "M"}${x} ${y}`).join(" ");
      return `<path d="${d}" fill="none" stroke="currentColor" stroke-width="${strokeWidth}" stroke-linecap="round" stroke-linejoin="round"/>`;
    })
    .join("");
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${s.w} ${s.h}" width="${s.w}" height="${s.h}">${paths}</svg>`;
}
